export interface TermsOfServiceStatusDto {
  currentVersion: string;

  hasAcceptedCurrentVersion: boolean;

  acceptedVersion?: string;
  /**
   * format: date-time
   */
  acceptedAt?: string;
}
